import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'confirm-mail',
  templateUrl: './confirm-mail.component.html',
  styleUrls: ['./confirm-mail.component.scss']
})
export class ConfirmMailComponent implements OnInit {

  currentUser: any;
  displayName: string;
  email: string;
  options: AnimationOptions = {
    path: '/assets/animations/spaceil-confirmed-mail.json',
    loop: true
  };

  constructor(private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.getCurrentUser().then(user => {
      this.currentUser = user;
    });
  }

  sendAgain(): void {
    this.authService.sendVerificationMail();
  }

  backHome(): void {
    this.router.navigate(['/login']);
  }

  animationCreated(animationItem: AnimationItem): void {
    // console.log(animationItem);
  }
}
